import { z } from 'zod';

import { phoneNumberValidity, t } from '@/lib/utils';

export const ContactDetailsSchema = () =>
    z
        .object({
            email: z
                .string()
                .min(1, t('general.atLeastOneLetter'))
                .regex(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, t('general.emailIsNotCorrect')),
            countryCode: z.string().min(1, t('general.atLeastOneLetter')),
            phone: z.string().regex(/^[0-9]+$/, t('general.onlyUseNumbers')),
            rawPhone: z.string().min(1),
            communicationLanguage: z.string().min(1),
        })
        .refine(personal => phoneNumberValidity(personal.countryCode, personal.phone), {
            message: t('general.invalidPhoneNumber'),
            path: ['phone'],
        });

export type ContactDetailsSchemaType = z.infer<ReturnType<typeof ContactDetailsSchema>>;
